import { Box, Typography } from "@mui/material";

const BenefitCard = ({ benefitDetails }) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: `1px dashed #0000001a`, pb: 2, mb: 2 }}>
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{benefitDetails?.benefit_name}</Typography>
                <Typography sx={{ color: '#636363', mb: 2 }}>{benefitDetails?.subtitle}</Typography>
                <Typography sx={{ color: benefitDetails?.status?.color, fontWeight: "bold" }}>{benefitDetails?.status?.display_name}</Typography>
            </Box>
            <Box>
                <img src={benefitDetails?.logo} alt='logo' style={{ maxHeight: 50, maxWidth: 50 }} />
            </Box>
        </Box>
    );
};

export default BenefitCard;